const _require = require('../lib/evaluateSource'),
  evaluateSource = _require.evaluateSource;

/**
 * @function evaluate - evaluates isDefinedBehavior
 */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const value = await evaluateSource(source.source, content, parentContentPath, transientContext, nativeFunctions);
  return value !== undefined;
};
module.exports = {
  evaluate
};